import { format, parseISO } from "date-fns";

/**
 * Formats a date string (ISO or yyyy-MM-dd) to "Mar 17, 2026" style.
 * Returns fallback if the input is falsy.
 */
export function formatDate(date: string | undefined | null, fallback = "—"): string {
  if (!date) return fallback;
  try {
    const parsed = date.includes("T") ? parseISO(date) : parseISO(date);
    return format(parsed, "MMM d, yyyy");
  } catch {
    return fallback;
  }
}
